module.exports = __webpack_public_path__ + "static/img/ISO9001_Renwu_1.97871a4d.jpg";